import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { colors } from '@styleseat/brand';
import { useMount } from '../../../hooks';
import analytics from '../../../modules/analytics';
import NotificationBanner from './NotificationBanner';
import { BasicCrownIcon } from '../../ui/Icons';

/**
 * Ambassador toolkit notification
 */
export default function AmbassadorToolkitNotification(props) {
  const { notification } = props;
  const localStart = moment(notification.local_start);
  const handleNotificationClick = () => {
    analytics.track('pro_ambassador_announcement_notification_clicked');
  };
  const dateText = `\n for ${localStart.format('dddd, MMM D')} at ${localStart.format('h:mm A')}`;

  useMount(() => {
    analytics.track('pro_ambassador_announcement_notification_viewed');
  }, []);

  return (
    <NotificationBanner
      notification={notification}
      icon={BasicCrownIcon}
      iconSize={36}
      iconColor={colors.sunshine}
      highlightBorderColor={colors.sunshine}
      highlightedText="Your official ambassador toolkit is here!"
      text={dateText}
      subText="Check your email inbox for tips on how to promote your link to grow your revenue."
      handleNotificationClick={handleNotificationClick}
    />
  );
}

AmbassadorToolkitNotification.propTypes = {
  /** The notification object */
  notification: PropTypes.object.isRequired,
};
